import { render } from "./singalTopImgToDo.vue?vue&type=template&id=50243668"
import script from "./singalTopImgToDo.vue?vue&type=script&lang=js"
export * from "./singalTopImgToDo.vue?vue&type=script&lang=js"
script.render = render

export default script